// @flow

import _ from 'lodash';
import React from 'react';
import cn from 'classnames';
import Responsive from 'client/components/common/Responsive';
import css from './Graph.scss';

const nationalLabel = 'ממוצע ארצי';
const value = Math.floor;

type nationalProps = {
	avarageScore: string,
};

type cityProps = {
	city: string,
	avarageScore: string,
};

type Props = {
	type: string,
	national: nationalProps,
	data: Array<cityProps>,
};

const getNationLinePosition = score => {
	const side = 'right';
	return {
		[side]: `${score}%`,
	};
};

const setNationalContentShiftVW = (score, node) => {
	const isMobile = Responsive.isMatching(Responsive.MOBILE);
	const scoreLimit = isMobile ? 75 : 90;
	const scoreMax = 100;
	const maxShift = isMobile ? 20 : 35;
	const shiftStep = maxShift / (scoreMax - scoreLimit);

	if (value(score) <= scoreLimit) {
		return;
	}

	node.style.left = `${(score - scoreLimit) * shiftStep}vw`;
};

const cityName = city => {
	const list = [
		'מודיעין-מכבים-רעות',
		'יהוד-מונוסון',
		'מעלות-תרשיחא',
		'כסרא-סמיע',
		'בנימינה-גבעת עדה',
		`בועיינה-נוג'ידאת`,
	];

	if (list.includes(city)) {
		return city.replace(/-/g, ' -');
	}

	return city;
};

const Graph = (props: Props) => {
	const [animate, setAnimate] = React.useState(0);
	const natContentRef = React.createRef();

	React.useEffect(() => {
		setAnimate(v => (v === 0 ? 1 : 0));
	}, [props.data]);

	React.useEffect(function setNationalContentShift() {
		const node = natContentRef.current;
		if (node) {
			setNationalContentShiftVW(nationalScore, node);

			const { x } = node.getBoundingClientRect();

			if (x < 0) {
				node.style.left = `${Math.abs(x) + 10}px`;
			}
		}
	});

	const id = _.get(props, 'national.id');
	const nationalScore = props.national.avarageScore;

	return (
		<div className={cn(css.graph, css[props.type])} data-animate={`animate-${animate}`}>
			<div className={css.nationalW}>
				<div className={css.national} style={getNationLinePosition(nationalScore)}>
					<div className={css.nationalContent} ref={natContentRef}>
						<span className={css.number}>{value(+nationalScore)}</span>
						<span className={css.label}>{nationalLabel}</span>
					</div>
					<div className={css.nationalLine} />
				</div>
			</div>
			{_.map(props.data, item => (
				<div className={css.item} key={`${id}-${item.avarageScore}-${item.city}`}>
					<div className={css.itemCity}>{cityName(item.city)}</div>
					<div className={css.itemValue}>
						<div className={css.bar} style={{ width: `${item.avarageScore}%` }}>
							<div className={cn(css.value, css.number)}>{value(item.avarageScore)}</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default Graph;
